import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";


type Props = {
    onActionEdit: (idEmpreendimento: number, openNewTab: boolean) => void,
    onActionDelete: (idEmpreendimento: number | null, openState: boolean) => void,
}

export const GenerateEmpreendimentoListaColumns = ({
    onActionEdit,
    onActionDelete,
}: Props): GridColDef[] => {

    return [
        {
            field: "nomeCentroCusto",
            filterable: false,
            headerName: "Centro Custo",
            width: 350,
            minWidth: 150,
            sortable: false,
        },
        {
            field: "descricao",
            filterable: false,
            headerName: "Descrição",
            flex: 1,
            minWidth: 150,
            sortable: false,
        },
        {
            field: 'idEmpreendimento',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            width: 100,
            minWidth: 100,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">
                        <IconButton
                            onMouseDown={e => {
                                if (e.button === 1) {
                                    onActionEdit(params.value, true);
                                } else {
                                    onActionEdit(params.value, e.ctrlKey);
                                }
                                e.preventDefault();
                            }}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        <IconButton onClick={() => onActionDelete(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>
                    </div>
                );
            }
        }

    ];

}